
export function formatPrice(val, withMarkup = true, fallback = '-') {
  if (val === null || isNaN(val)) {
    if (withMarkup) {
      return `<span class="text-nowrap">${fallback}</span>`;
    }

    return fallback;
  }

  if (withMarkup) {
    return `<span class="text-nowrap">kr ${val.toLocaleString('nb', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}</span>`;
  }

  return val.toLocaleString('nb', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function validateNumber(val, minVal = 1) {
  if (typeof val === 'number') {
    return val >= minVal ? val : minVal;
  }

  return minVal;
}

export function randomString() {
  return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
}

// See config/vismaCountries.php for more codes
export function getCountryNameByCode(code) {
  switch (parseInt(code, 10)) {
    case 0:
    case 578:
      return 'Norge';
    case 752:
      return 'Sverige';
    case 208:
      return 'Danmark';
    default:
      return '';
  }
}

export function diffPercent(lowNum = 0, highNum = 0) {
  if (isNaN(lowNum) || isNaN(highNum)) {
    return 0;
  }

  // eslint-disable-next-line eqeqeq
  if (lowNum == 0 && highNum != 0) {
    return 100;
  }

  // eslint-disable-next-line eqeqeq
  if (highNum == 0) {
    return 0;
  }

  return Math.abs(Math.round(((highNum - lowNum) / highNum) * 100));
}

export function formatPriceDataLayer(value, withThousands = false) {
  let newValue;

  if (withThousands) {
    newValue = value / 100;
  } else {
    newValue = value;
  }

  return newValue.toFixed(2);
}
